import { useQuery } from "react-query";
import { getOrgUnitSDGReport } from "../../api/ou/orgUnitSDGReport";

export const useOrgUnitSDGReport = (crisId, onSuccess) => {
    return useQuery("get-org-unit-sdg-report",() => getOrgUnitSDGReport(crisId), {
      onSuccess,
    });
}